import { Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import CalendorIcon from "../../../src/assests/images/calendar-2.svg";
import * as XLSX from "xlsx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Reportdropdown from "./Reportdropdown";
import CollapsibleTable from "./Task/ReportTable";
import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SystemUpdateAltSharpIcon from "@mui/icons-material/SystemUpdateAltSharp";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Plus from "../../../src/assests/images/Plus.svg";
import Export from "../../../src/assests/images/export.svg";
import FilterAdd from "../../../src/assests/images/filter-add.svg";
import FilterPopup from "./FilterPopup";
import { useLocation } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { getallcsvdata, getalltaskids, getfilterdata } from "./api";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { array, string } from "yup";
import { isAbsolute } from "path";
import FilterPopover from "./FilterPopupv1";
import { getToken } from "../../utils/utils";
import DropDownFilter from "./RetailerAll/DropDownFilter";

const columns: Option[] = [
  { label: "User ID", value: "user_id" },
  { label: "User Name", value: "user_name" },
  { label: "Outlet Name", value: "outlet_name" },
  { label: "Location", value: "location" },
  { label: "Member Since", value: "member_since" },
  { label: "Total Points", value: "total_points" },
  { label: "Phone Number", value: "phone" },
  { label: "Current Points", value: "current_points" },
];

export interface Option {
  label: string;
  value: string;
  disabled?: boolean;
}

function Taskreports() {
  interface RowData {
    user_id: string;
    retailer_name: string;
    outlet_name: string;
    locations: string;
    pmi_entity_code: string;
    outlet_type: string;
    on_going_task: string;
    total_points: number;
  }
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("All Locations");
  const [selectedTask, setSelectedTask] = useState("All Tasks");
  const startDate = dateRange[0];
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const endDate = dateRange[1];
  const [selectedRange, setSelectedRange] = useState("Today");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [filteredRows, setFilteredRows] = useState<RowData[]>([]);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [filters, setFilters] = useState<Array<any>>([])
  const token = getToken();
  const [tags, setTags] = useState<string[]>([]);
  const [selectedCols, setSelectedCols] = useState<string[]>([]);
  const reportDropdownOptions1 = [
    { value: "All Locations", label: "All Locations" },
    { value: "Delhi", label: "Delhi" },
    { value: "Mumbai", label: "Mumbai" },
  ];

  const reportDropdownOptions2 = [
    { value: "All Tasks", label: "All Tasks" },
    { value: "Availability Task", label: "Availability Task" },
    { value: "Education Task", label: "Education Task" },
    { value: "Volume Education", label: "Volume Education" },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const togglePopup = () => {
    setIsPopupOpen((prev) => !prev); // This will now toggle the state correctly
  };
  const handleOutsideClick = useCallback((event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      console.log("Clicked outside, closing popup...");
      setIsPopupOpen(false); // Close the popup when clicking outside
    }
  }, []);

  useEffect(() => {
    if (isPopupOpen) {
      // Add event listener for closing when clicking outside
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      // Cleanup the event listener when the popup is closed
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      // Cleanup listener on component unmount
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isPopupOpen]);

  const location = useLocation();

  const { data, Loc, filteratatafirst } = location.state || {};

  const [locValue, setLocValue] = useState<string | undefined>();

  const [LocValulocationsdata, setLocValulocationsdata] = useState<any[]>([]);




  useEffect(() => {
    if (location.state?.Loc) {
      setLocValue(location.state.Loc);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.filteredDatafinalforlocations) {
      setLocValulocationsdata(location.state.filteredDatafinalforlocations);
    }
  }, [location.state]);

  console.log(LocValulocationsdata, "LocValulocationsdataLocValulocationsdata");

  useEffect(() => {
    if (location.state?.tasklocations) {
      console.log(
        location.state?.tasklocations,
        "location.state?.tasklocations"
      );
      // setLocValue(location.state.Loc);
    }
  }, [location.state]);

  const [taskdetails22, settaskdetalsi22] = useState<any[]>([]);

  const [selectedtaskdetailsids, setselectedtaskids] = useState<number[]>([]);

  useEffect(() => {
    if (location.state?.updatevaes) {
      setselectedtaskids(location.state.updatevaes);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.taskDetails1122) {
      settaskdetalsi22(location.state.taskDetails1122);
    }
  }, [location.state]);

  const rows = useMemo(() => {
    if (!data) return [];

    const filteredData = data.filter((item: any) => item.locations === Loc);
    console.log();
    const mappedRows = filteredData.map((item: any) => ({
      user_id: item.user_id,
      retailer_name: item.retailer_name,
      outlet_name: item.outlet_name,
      locations: item.locations,
      pmi_entity_code: item.pmi_entity_code,
      outlet_type: item.outlet_type,
      on_going_task: `Task ${item.on_going_task}`,
      total_points: item.total_points,
    }));

    return mappedRows;
  }, [data, Loc]);

  const [debouncedSearchQuery] = useDebounce(searchQuery, 500);
  useEffect(() => {
    if (debouncedSearchQuery.trim()) {
    } else {
      setFilteredRows(rows);
    }
  }, [debouncedSearchQuery]);


  const [selectedtaskids, setSelectedtaskids] = useState<number[]>([]);
  const [dropdowntasks, setDropdowntasks] = useState<
    { value: number; name: string }[]
  >([]);

  const [dropdowntaskids, setdropdowntaskids] = useState<string[]>([]);

  const [taskidsfilters, settaslidsFilters] = useState<{
    [key: string]: boolean;
  }>({
    all: true,
  });

  const [idid, setidid] = useState<Record<string, (string | null)[]>>({});
  const navigate = useNavigate();
  const [taskDetails, setTaskDetails] = useState([]);
  const [applydetailes, setapply] = useState(false);
  const [locationsfinal, setlocationsfinal] = useState<string | null>(null);

  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [csvData, setCsvData] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [appliedFilters, setAppliedFilters] = useState<Record<string, string[]>>({});

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the popover

    setTimeout(() => {
      setapply(false); // Run after 1 second
    }, 1000); // 1000ms = 1 second
  };

  type SelectedFilters = Record<string, { value: string; id: string | null }[]>;

  const handleApplyFilters = (filters: SelectedFilters) => {
    console.log(filters, "filterssssssssssssssss");
    // Extract values and IDs separately
    const transformedFilters: Record<string, string[]> = {};
    const filterIds: Record<string, (string | null)[]> = {};

    Object.keys(filters).forEach((key) => {
      // Handle values normally
      transformedFilters[key] = filters[key].map(item => item.value);

      if (key === "Tasks") {
        // For "Tasks", append the ids instead of replacing them
        filterIds[key] = (filterIds[key] || []).concat(filters[key].map(item => item.id));
      } else {
        // For other keys, just set the ids
        filterIds[key] = filters[key].map(item => item.id);
      }
    });

    // Save both value and id
    setAppliedFilters(transformedFilters);
    setidid(filterIds); // ✅ Now correctly storing IDs
    // setlocationsfinal(transformedFilters.Location.join(','))


    console.log("Applied Filtefffffrs:", transformedFilters);
    console.log("Filter IDs:", filterIds);
  };

  // useEffect(() => {
  //   getfilterdata(token, locationsfinal).then((res) => {
  //     if (res.status) {
  //       console.log(res.data.data, "resdata");
  //       setFilters(res?.data?.data || []);
  //     }
  //   });
  // }, [token, locationsfinal]);

  console.log(idid, "idididid")
  console.log(dateRange[0], dateRange[1], "ffffffffffffffffffffff")

  const values = LocValulocationsdata.map((item) => item.value);
  console.log(selectedtaskdetailsids, "selectedtaskdetailsidseeeeeee")
  console.log(appliedFilters.Tasks, "lllllllllllllll")
  console.log(appliedFilters.Location, "bbbbbbbbbbb")
  console.log(appliedFilters, "appliedFiltersddddddddddd")


  const prevSelectedtasksmaindates = useRef<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const formattedDateRange = dateRange.map(date => date ? date.toISOString() : null).join(" - ");
  const startDate1 = dateRange[0]
    ? new Date(dateRange[0]).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
    : null;

  const endDate1 = dateRange[1]
    ? new Date(dateRange[1]).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
    : null;
  useEffect(() => {
    if (
      dateRange.length > 0 &&
      (dateRange[0] !== prevSelectedtasksmaindates.current[0] ||
        dateRange[1] !== prevSelectedtasksmaindates.current[1])
    ) {
      console.log(dateRange, "selectedTaskstatus updated");

      navigate(`/reports/tasks`, {
        state: { startDate: dateRange[0], endDate: dateRange[1] },
      });

      prevSelectedtasksmaindates.current = [...dateRange];
    }
  }, [dateRange, navigate]);



  const prevSelectedtasksmainlocations = useRef<string[]>([]);

  useEffect(() => {
    const locations = appliedFilters.Location || [];

    if (
      locations.length > 0 &&
      JSON.stringify(locations) !== JSON.stringify(prevSelectedtasksmainlocations.current)
    ) {
      console.log(locations, "selectedTaskstatus updated");

      navigate(`/reports/tasks`, {
        state: { selectedtaskmainlocations: locations },
      });

      prevSelectedtasksmainlocations.current = locations;
    }
  }, [appliedFilters.Location, navigate]);

  const prevSelectedtasksmaintasknames = useRef<string[]>([]);

  useEffect(() => {
    // Ensure Tasksmain contains only strings
    const Tasksmain = (idid.Tasks || []).filter((task) => task !== null) as string[];

    if (
      Tasksmain.length > 0 &&
      JSON.stringify(Tasksmain) !== JSON.stringify(prevSelectedtasksmaintasknames.current)
    ) {
      console.log(Tasksmain, "selectedTaskstatus updated");

      navigate(`/reports/tasks`, {
        state: { selectedtasksnamesFilters: Tasksmain },
      });

      prevSelectedtasksmaintasknames.current = Tasksmain;
    }
  }, [idid.Tasks, navigate]);

  const prevSelectedtasksmaintasktypes = useRef<string[]>([]);

  useEffect(() => {
    const tasktypes = appliedFilters.TaskType || [];

    if (
      tasktypes.length > 0 &&
      JSON.stringify(tasktypes) !== JSON.stringify(prevSelectedtasksmaintasktypes.current)
    ) {
      console.log(tasktypes, "selectedTaskstatus updated");

      navigate(`/reports/tasks`, {
        state: { selectedtaskstypeeeFilters: tasktypes },
      });

      prevSelectedtasksmaintasktypes.current = tasktypes;
    }
  }, [appliedFilters.TaskType, navigate]);

  const prevSelectedtasksmaintaskstatus = useRef<string[]>([]);

  useEffect(() => {
    const taskstatus = appliedFilters.Status || [];

    if (
      taskstatus.length > 0 &&
      JSON.stringify(taskstatus) !== JSON.stringify(prevSelectedtasksmaintaskstatus.current)
    ) {
      console.log(taskstatus, "selectedTaskstatus updated");

      navigate(`/reports/tasks`, {
        state: { selectedSelectedmainstatus: taskstatus },
      });

      prevSelectedtasksmaintaskstatus.current = taskstatus;
    }
  }, [appliedFilters.Status, navigate]);


  console.log(appliedFilters, "appliedFilterseeeewwwwqqqqqqq")


  const handleExportClick = async () => {
    try {
      const task_id =
        Array.isArray(idid.Tasks) && idid.Tasks.length > 0
          ? idid.Tasks.join(",")
          : "";
      const Task_type =
        Array.isArray(appliedFilters.TaskType) &&
          appliedFilters.TaskType.length > 0
          ? appliedFilters.TaskType.join(",")
          : "";
      const Task_Status =
        Array.isArray(appliedFilters.Status) &&
          appliedFilters.Status.length > 0
          ? appliedFilters.Status.join(",")
          : "";
      const locations =
        Array.isArray(appliedFilters.Location) &&
          appliedFilters.Location.length > 0
          ? appliedFilters.Location.join(",")
          : "";
      const Taskstartdate = startDate1 ? startDate1 : "";
      const Taskenddate = endDate1 ? endDate1 : "";

      const queryParams = new URLSearchParams({
        task_id: task_id,
        task_type: Task_type,
        task_status: Task_Status,
        location: locations,
        task_start_date: Taskstartdate,
        task_end_date: Taskenddate,
      }).toString();

      const query = `/reports/generate-report_v1?${queryParams}`;

      const response = await getallcsvdata(query);

      if (response.headers["content-type"] === "application/json") {
        console.error("Expected binary data but got JSON.");
        return;
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        const data = event.target?.result;
        if (!data) {
          console.error("No data found in the file.");
          return;
        }

        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        let jsonData: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        const dateColumns = [10, 22, 23];

        jsonData = jsonData.map((row, rowIndex) => {
          return row.map((cell, colIndex) => {
            if (typeof cell === "number" && dateColumns.includes(colIndex)) {
              return parseExcelDate(cell);
            }
            return cell;
          });
        });

        console.log(jsonData, "Formatted JSON Data");

        const csvContent = XLSX.utils.sheet_to_csv(sheet);
        const csvBlob = new Blob([csvContent], { type: "text/csv" });
        const csvUrl = URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.href = csvUrl;
        a.download = "exported_data.csv";
        a.click();
        URL.revokeObjectURL(csvUrl);
      };

      fileReader.readAsArrayBuffer(blob);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  function parseExcelDate(serial: number) {
    if (!serial || isNaN(serial)) return "Invalid Date";
    const unixEpoch = new Date(1900, 0, 1);
    const msInDay = 86400000;
    const adjustedSerial = serial - 2;
    const date = new Date(unixEpoch.getTime() + adjustedSerial * msInDay);
    return isNaN(date.getTime()) ? "Invalid Date" : format(date, "MM/dd/yyyy");
  }

  console.log(selectedRange, "8888888888888855555555555")



  return (
    <div>
      <Box
        sx={{
          // display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "32px",
          backgroundColor: "#ffffff",
          borderBottom: "1px solid #E7E8E9"
        }}
      >
        <Box>
          <Link
            href="#"
            sx={{
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "500",
              color: "rgba(105, 106, 107, 1)",
            }}
          >
            Reports
          </Link>
          <Typography
            variant="h3"
            sx={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#000",
              marginTop: "16px",
              marginBlockEnd: "24px"
            }}
          >
            Report
          </Typography>
          <Box sx={{ minWidth: 120 }}>
            {/* <FormControl fullWidth>
              <InputLabel id="multi-select-label">Task Names</InputLabel>
              <Select
                labelId="multi-select-label"
                id="multi-select"
                multiple
                value={selectedtaskids}
                onChange={handleChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((taskId) => {
                      const task = dropdowntasks.find(
                        (t) => t.value === taskId
                      );
                      return <Chip key={taskId} label={task?.name} />;
                    })}
                  </Box>
                )}
              >
                {dropdowntasks.map((task) => (
                  <MenuItem key={task.value} value={task.value}>
                    {task.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // marginTop: "16px",
            // padding: "0 32px",
          }}
        >
          <Box sx={{ maxWidth: "520px", flexGrow: 1 }}>
            <TextField
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                ".MuiOutlinedInput-root": {
                  border: "none",
                  background: "#FFF",
                  color: "rgba(167, 168, 169, 1)",
                  borderRadius: "12px",
                  height: "48px",
                  width: "521px",
                  fontSize: "16px",
                  fontWeight: "500",
                  margin: "10px 0 0px",
                  "& input::placeholder": {
                    color: "rgba(167, 168, 169, 1)",
                    opacity: 1,
                  },
                },
                fontSize: "14px",

                width: "100%",

                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "2px solid #F5F5F5",
                  },
                  "&:hover fieldset": {
                    borderColor: "#000",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#000",
                  },
                },
              }}
              placeholder="Search by Reports, Pmi Entity Code, Retailer Name, Outlet Name, Locations "
              type="search"
              variant="outlined"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search
                      sx={{
                        background: "#FFFFFF00",
                        height: "30px",
                        width: "20px",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box sx={{ display: "flex" }}>
            {
              <Box sx={{ marginRight: "8px", width: "301px" }}>
                <DatePicker
                  // placeholderText="1 Sep 2024 to 15 Dec 2024"
                  selectsRange={true}
                  startDate={startDate || undefined}
                  endDate={endDate || undefined}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  customInput={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        padding: "0 10px",
                        height: "48px",
                        boxSizing: "border-box",
                        width: "301px",
                      }}
                    >
                      <input
                        style={{
                          fontSize: "14px",
                          border: "none",
                          outline: "none",
                          flex: 1,
                          color: "#000",
                          backgroundColor: "transparent",
                        }}
                        value={
                          dateRange[0]
                            ? `${dateRange[0].toLocaleDateString()}${dateRange[1]
                              ? ` to ${dateRange[1].toLocaleDateString()}`
                              : ""
                            }`
                            : ""
                        }
                        readOnly
                        placeholder="Select date"
                      />
                      <img
                        src={CalendorIcon}
                        alt="Plus Icon"
                        style={{
                          height: "20px",
                          width: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  }
                />
              </Box>
            }
          </Box>
        </Box>
        {/* <Box>
          <Button
            sx={{
              borderRadius: "8px",
              padding: "14px 16px",
              color: "#FFF",
              textDecoration: "none",
              background: "rgba(200, 23, 47, 1)",
              textAlign: "center",
              fontSize: "14px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" /> Create
            Task
          </Button>
        </Box> */}
      </Box>


      <Box
        sx={{
          padding: "5px 32px 32px",
          // marginTop: "20px",
          borderRadius: "12px",
          background: "#F9FBFC",
          // borderTop: "1px solid #E7E8E9",
          boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
        }}
      >
        <Box
          sx={{
            background: "#fff",
            borderRadius: "12px",
            border: "1px solid #E4E7EC",
            marginTop: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "15px 0 5px",
              padding: "0px 32px 10px",
            }}
          >
            {rows.length ? (
              <Typography
                variant="body1"
                sx={{ fontSize: "16px", fontWeight: "600" }}
              >
                {/* Total {rows.length} Users */}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                sx={{ fontSize: "16px", fontWeight: "600" }}
              >
                {/* Total 0 Users */}
              </Typography>
            )}

            <Box sx={{ display: "flex" }}>
              {/* <Box sx={{ marginRight: "20px", width: "230px" }}>
                <DropDownFilter

                  placeholder="Select columns"
                  options={columns}
                  value={selectedCols}
                  onChange={setSelectedCols}
                />
              </Box> */}
              <Button
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  backgroundColor: "#fff",
                  height: "40px",
                  padding: "16px",
                  marginRight: "10px",
                  borderRadius: "10px",
                  color: "#565656",
                  border: "1px solid #DEDEDE",
                  boxShadow: "none",
                  fontSize: "14px",
                  fontWeight: "500",
                  "&:hover": {
                    backgroundColor: "#fff",
                  },
                  "& .MuiButton-endIcon": {
                    fontSize: "30px",
                    color: "var(--Icon-Colour, #5E5E5E)",
                  },
                }}
                startIcon={<img src={FilterAdd} alt="filter-add" />}
                onClick={handleOpen}
              // onClick={(event) => {
              //   // togglePopup();

              // }}
              >
                Filters
              </Button>

              {/* {isPopupOpen && ( */}
              <div ref={popupRef} style={{ marginTop: "40px" }}>
                {/* <FilterPopup closePopup={togglePopup} rows={rows} /> */}
                {/* <FilterPopover anchorEl={anchorEl} filterData1={filters} onClose={handleClose} onApply={handleApplyFilters} /> */}
                <FilterPopover anchorEl={anchorEl} filterData1={filters} onClose={handleClose} onApply={handleApplyFilters} tags={tags}
                  setTags={setTags} appliedFilters={appliedFilters} startDate1={startDate1}
                  endDate1={endDate1} selectedRange={selectedRange}
                  setSelectedRange={setSelectedRange} selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab} applydetailes={applydetailes}
                  setapply={setapply} />
              </div>
              {/* )} */}

              <Button
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  backgroundColor: "#fff",
                  fontSize: "14px",
                  fontWeight: "500",
                  height: "40px",
                  padding: "16px",
                  borderRadius: "10px",
                  color: "#C8172F",
                  border: "1px solid #C8172F",
                  boxShadow: "none",
                  "&:hover": {},
                  "& .MuiButton-endIcon": {
                    fontSize: "30px",
                    color: "var(--Icon-Colour, #C8172F)",
                  },
                  "&:before, &:after": {
                    border: "none",
                  },
                }}
                startIcon={<img src={Export} alt="export"></img>}
                onClick={() => handleExportClick()}
              >
                Export CSV
              </Button>
            </Box>
          </Box>

          <CollapsibleTable
            selectedRange={selectedRange}
            applydetailes={applydetailes}
            selectedTab={selectedTab}
            searchQuery={searchQuery ? searchQuery : ""}
            taskDetails={taskdetails22}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            dateRange={formattedDateRange}
            startDate1={startDate1}
            endDate1={endDate1}
            idid={idid}
            tags={tags}
            setTags={setTags}
          />
        </Box>
      </Box>
    </div>
  );
}

export default Taskreports;